import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {ModalController} from "@ionic/angular";
import {Client} from "../../models/client.model";
import {VetClinic, VetDoctor} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {VetineoVisitTypeBundleService} from "../../providers/vetineo-visit-type-bundle.service";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";
import {VetDoctorVetVisitType} from "../../models/vet-doctor-vet-visit-type.model";

@Component({
  selector: 'app-vet-doctor-visit-type-importer',
  templateUrl: './vet-doctor-visit-type-importer.component.html',
  styleUrls: ['./vet-doctor-visit-type-importer.component.scss'],
})
export class VetDoctorVisitTypeImporterComponent implements OnInit {
  isGeneralAdmin: boolean;
  isClientAdmin: boolean;
  isGeneralClientAdmin: boolean;
  vetClinic: VetClinic;
  isBusy: boolean;
  isBusyLoading: boolean;
  clientSelected: Client;
  clinicSelected: VetClinic;
  clinics: VetClinic[];
  subscriptions: Subscription = new Subscription();
  selectOptions: any = {
    header: 'Wybierz lecznicę'
  };

  @Output() actionCanceledEmitter = new EventEmitter<boolean>();
  @Output() objectAddedEmitter = new EventEmitter<boolean>();

  doctors: VetDoctor[];
  bundles: VetineoVisitTypeBundle[];
  doctorsSelected: VetDoctor[] = [];
  bundlesSelected: VetineoVisitTypeBundle[] = [];
  selectDoctorsAndBundles: boolean = true;
  doctorsVisitTypeMaps = new Map<VetDoctor, VetDoctorVetVisitType[]>();
  configureDoctorsText: any = 'Krok II: Skofiguruj i potwierdź';
  chooseDoctorsText: any = 'Krok I: Wybierz lekarzy i typy wizyt';


  constructor(private modalController: ModalController, private appStateService: AppStateService,
              private vetClinicService: VetClinicService, private commonUtils: CommonUtils,
              private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService) {
  }

  ngOnInit() {
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clinicSelected = null;
        this.clientSelected = data.data;
        this.fetchBundles();
        this.appStateService.updateIsBusySubject(true);
        this.isBusyLoading = true;
        this.registerSubscription(this.vetClinicService.listClinicsForClient(this.clientSelected.uuid).subscribe(e => {
          if (e) {
            this.clinics = e;
            if (this.clinics?.length == 1) {
              this.clinicSelected = this.clinics[0];
              this.fetchDoctors();
            }
            this.appStateService.updateIsBusySubject(false);
          } else {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
          }
        }));
      }
    });

    return await modal.present();

  }


  getName(vetineoVisitTypeBundle: VetineoVisitTypeBundle) {
    if (vetineoVisitTypeBundle.nameAdditionPL) {
      return `${vetineoVisitTypeBundle.namePL} (${vetineoVisitTypeBundle.nameAdditionPL})`;
    } else {
      return vetineoVisitTypeBundle.namePL;
    }

  }

  onSelectClinic($event: any) {
    this.clinicSelected = $event.detail.value;
    this.fetchDoctors();
  }

  getSelectedText() {
    if (this.clinicSelected) {
      return this.clinicSelected.clinicName;
    } else {
      return '';
    }
  }


  private fetchDoctors() {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetClinicService.getSpecificVetClinic(this.clinicSelected.uuid).subscribe(e => {
      if (e) {
        this.doctors = e.team;
        this.doctorsSelected = [];
        this.bundlesSelected = [];
      }
      this.isBusyLoading = false;
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));

  }

  private fetchBundles() {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetineoVisitTypeBundleService.getBundlesByClientUUID(this.clientSelected.uuid)
      .subscribe(e => {
        if (e) {
          this.bundles = e;
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);
      }));

  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  onDoctorCheckboxChange($event, vetDoctor: any) {
    if ($event.detail.checked) {
      this.doctorsSelected.push(vetDoctor);
    } else {
      this.doctorsSelected = this.doctorsSelected.filter(e => e.uuid !== vetDoctor.uuid);
    }
  }

  onBundleCheckboxChange($event, bundle: any) {
    if ($event.detail.checked) {
      this.bundlesSelected.push(bundle);
    } else {
      this.bundlesSelected = this.bundlesSelected.filter(e => e.uuid !== bundle.uuid);
    }
  }

  onCancel() {
    this.actionCanceledEmitter.emit(null);
  }

  getDoctorName(vetDoctor: VetDoctor) {
    if (vetDoctor.defaultVisitMinutes) {
      return vetDoctor.name;
    } else {
      return vetDoctor.name + ' (ustaw czas standardowy)';
    }
  }

  onPrepareBundles() {
    this.doctorsSelected.forEach(doctor => {
      let vetDoctorVetVisitTypes = this.bundlesSelected.map(bundle => {
        let vetDoctorVetVisitType = VetineoVisitTypeBundle.asVetDoctorVetVisitType(bundle);
        vetDoctorVetVisitType.vetDoctorUUID = doctor.uuid;
        vetDoctorVetVisitType.vetDoctor = doctor;
        vetDoctorVetVisitType.minutes = doctor.defaultVisitMinutes;
        return vetDoctorVetVisitType;
      });
      this.doctorsVisitTypeMaps.set(doctor, vetDoctorVetVisitTypes);
    });
    this.selectDoctorsAndBundles = false;
  }

  checkSettings() {
    return !this.selectDoctorsAndBundles;
  }

  onAddedObj() {
    this.objectAddedEmitter.emit(true)
  }
}
